export const actionTypes = {
  START_REQUEST: 'APP.INCOMING_DATA.EMAIL.SAVE.START_REQUEST',
  REQUEST_SUCCESS: 'APP.INCOMING_DATA.EMAIL.SAVE.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.INCOMING_DATA.EMAIL.SAVE.REQUEST_FAILURE',
};

export function startRequest(email) {
  return {
    type: actionTypes.START_REQUEST,
    payload: email,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
